module.exports = __webpack_public_path__ + "static/media/organization.b81bfeab.png";